/**
 * This file was auto-generated by Fern from our API Definition.
 */

export type AnnotationQueueStatus = "PENDING" | "COMPLETED";
export const AnnotationQueueStatus = {
  Pending: "PENDING",
  Completed: "COMPLETED",
} as const;
